var _path, _path2, _path3, _path4, _path5, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavicon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0.00397574 9.12785C-0.120303 6.10516 2.66377 1 9.10296 1C15.5422 1 18 6.19689 18 9.85841C18 12.4923 16.7395 17.2655 10.6442 18.9494C9.44473 19.2803 8.52374 17.9164 9.28494 16.9467C9.50465 16.666 9.71548 16.3548 9.91411 16.0053C10.52 14.9417 9.38259 13.7503 8.24966 14.245C6.85818 14.8522 5.11827 15.1809 3.1287 14.5934C0.016182 13.6739 0.00397574 9.12785 0.00397574 9.12785Z",
    fill: "url(#paint0_linear_3463_4793)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23158 9.52611C3.23158 9.89344 3.3775 10.2457 3.63724 10.5055C3.89698 10.7652 4.24926 10.9111 4.61658 10.9111C4.98391 10.9111 5.33619 10.7652 5.59593 10.5055C5.85566 10.2457 6.00158 9.89344 6.00158 9.52611C6.00158 9.15879 5.85566 8.80651 5.59593 8.54677C5.33619 8.28703 4.98391 8.14111 4.61658 8.14111C4.24926 8.14111 3.89698 8.28703 3.63724 8.54677C3.3775 8.80651 3.23158 9.15879 3.23158 9.52611Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62758 6.38589C5.62758 6.69142 5.74895 6.98443 5.96499 7.20047C6.18103 7.41652 6.47405 7.53789 6.77958 7.53789C7.08511 7.53789 7.37812 7.41652 7.59417 7.20047C7.81021 6.98443 7.93158 6.69142 7.93158 6.38589C7.93158 6.2346 7.90178 6.0848 7.84389 5.94504C7.78599 5.80527 7.70114 5.67827 7.59417 5.5713C7.48719 5.46433 7.3602 5.37947 7.22043 5.32158C7.08066 5.26368 6.93086 5.23389 6.77958 5.23389C6.6283 5.23389 6.47849 5.26368 6.33873 5.32158C6.19896 5.37947 6.07197 5.46433 5.96499 5.5713C5.85802 5.67827 5.77316 5.80527 5.71527 5.94504C5.65738 6.0848 5.62758 6.2346 5.62758 6.38589Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19458 5.42911C9.19458 5.54901 9.2182 5.66773 9.26408 5.7785C9.30996 5.88927 9.37721 5.98992 9.46199 6.0747C9.54677 6.15948 9.64742 6.22673 9.75819 6.27262C9.86896 6.3185 9.98768 6.34211 10.1076 6.34211C10.2275 6.34211 10.3462 6.3185 10.457 6.27262C10.5677 6.22673 10.6684 6.15948 10.7532 6.0747C10.8379 5.98992 10.9052 5.88927 10.9511 5.7785C10.997 5.66773 11.0206 5.54901 11.0206 5.42911C11.0206 5.30922 10.997 5.19049 10.9511 5.07972C10.9052 4.96895 10.8379 4.8683 10.7532 4.78352C10.6684 4.69874 10.5677 4.63149 10.457 4.58561C10.3462 4.53973 10.2275 4.51611 10.1076 4.51611C9.98768 4.51611 9.86896 4.53973 9.75819 4.58561C9.64742 4.63149 9.54677 4.69874 9.46199 4.78352C9.37721 4.8683 9.30996 4.96895 9.26408 5.07972C9.2182 5.19049 9.19458 5.30922 9.19458 5.42911Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8372 13C10.5977 13 10.3604 12.8814 10.1946 12.6513C10.1241 12.5536 10.0709 12.4406 10.0381 12.319C10.0053 12.1974 9.9935 12.0695 10.0034 11.9426C10.0133 11.8157 10.0446 11.6923 10.0957 11.5795C10.1468 11.4667 10.2165 11.3666 10.301 11.2851L18.6267 3.22511C18.9817 2.88236 19.5097 2.93692 19.8054 3.34845C19.8759 3.44622 19.9291 3.55913 19.9619 3.68074C19.9947 3.80235 20.0065 3.93026 19.9966 4.05716C19.9867 4.18406 19.9554 4.30745 19.9043 4.42028C19.8532 4.53311 19.7835 4.63316 19.699 4.71471L11.3733 12.7747C11.2231 12.9206 11.0332 13.0004 10.8372 13Z",
    fill: "#7B67FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3463_4793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 6.79321C16.8088 6.17911 16.5679 5.57459 16.2745 5L10.2809 11.269C9.94915 11.6162 9.90518 12.2339 10.1814 12.6481C10.2547 12.7584 10.3465 12.8471 10.4502 12.9079C10.554 12.9687 10.6672 13.0002 10.7818 13C10.9586 13 11.1364 12.9258 11.2827 12.7726L17 6.79321Z",
    fill: "#7E58E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3463_4793",
    x: 9,
    y: 4,
    width: 9,
    height: 10,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_3463_4793"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3463_4793",
    x1: 6.70552e-8,
    y1: 10,
    x2: 18,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C082FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7967FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavicon2);
export default __webpack_public_path__ + "static/media/navicon2.45b2e15aaedc36488e707cd72dc95731.svg";
export { ForwardRef as ReactComponent };